import React from "react"

import {Col, Row} from "@irati/ui/src/ColumnRow"
import {Body} from "@irati/ui/src/Typography"
import Expand from "@irati/ui/src/Expander"
import {injectIntl, InjectIntl, FormattedMessage, FormattedCurrency} from "@irati/utils/lang"

interface Props extends InjectIntl {
  net: number,
  vat: number,
  currency: string
}

const VAT: React.FC<Props> = ({net, vat, formatMessage, currency}) => (
  <div className="orderSummaryVAT">
    <Expand
      HeaderLabel={(props) => <Body small weight="bold" color="ink" {...props} />}
      showText={formatMessage({id: "perks.components.orderSummary.vat.vatSummary"})}>
      <Row paddingTop={1}>
        <Col xs={8}>
          <Body small>
            <FormattedMessage id="perks.components.orderSummary.vat.netAmount" />
          </Body>
        </Col>
        <Col xs={4}>
          <div className="pull-right">
            <Body small>
              <FormattedCurrency currency={currency} value={net} />
            </Body>
          </div>
        </Col>
      </Row>
      <Row paddingTop={1}>
        <Col xs={8}>
          <Body small>
            <FormattedMessage id="perks.components.orderSummary.vat.vat" />
          </Body>
        </Col>
        <Col xs={4}>
          <div className="pull-right">
            <Body small>
              <FormattedCurrency currency={currency} value={vat} />
            </Body>
          </div>
        </Col>
      </Row>
    </Expand>
    <hr />
  </div>
)

export default injectIntl(VAT)
